import find from 'lodash/find';
import filter from 'lodash/filter';
import sortBy from 'lodash/sortBy';
import findIndex from 'lodash/findIndex';
import keyBy from 'lodash/keyBy';
var BeeModelCollection = /** @class */ (function () {
    function BeeModelCollection(ModelClass, modelManager, models, options) {
        if (options === void 0) { options = {}; }
        this.ModelClass = ModelClass;
        this.modelManager = modelManager;
        this.models = models;
        this.options = options;
        this.modelsHash = {};
        this.modelsByNameHash = {};
        this.modelsHash = keyBy(models, "id");
        this.modelsByNameHash = keyBy(models, "name");
    }
    Object.defineProperty(BeeModelCollection.prototype, "classConstructor", {
        get: function () {
            return this.constructor;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BeeModelCollection.prototype, "size", {
        get: function () {
            return this.models.length;
        },
        enumerable: false,
        configurable: true
    });
    BeeModelCollection.prototype.createCollection = function (models) {
        return new this.classConstructor(this.ModelClass, this.modelManager, models, this.options);
    };
    BeeModelCollection.prototype.first = function () {
        return this.all()[0] || null;
    };
    BeeModelCollection.prototype.firstOrFail = function () {
        var record = this.first();
        if (record === null)
            throw new Error("No records found in collection " + this.classConstructor.name);
        return record;
    };
    BeeModelCollection.prototype.all = function () {
        return this.models;
    };
    BeeModelCollection.prototype.map = function (filterFoo) {
        var records = this.all().map(filterFoo);
        return this.createCollection(records);
    };
    BeeModelCollection.prototype.filter = function (predicate) {
        var records = filter(this.all(), predicate);
        return this.createCollection(records);
    };
    BeeModelCollection.prototype.find = function (predicate) {
        return find(this.all(), predicate);
    };
    BeeModelCollection.prototype.findById = function (id) {
        return this.modelsHash[+id] || null;
    };
    BeeModelCollection.prototype.findIndex = function (id) {
        return findIndex(this.all(), function (m) { return m.id === +id; });
    };
    BeeModelCollection.prototype.sortAsc = function (predicate) {
        var records = sortBy(this.all(), predicate);
        return this.createCollection(records);
    };
    BeeModelCollection.prototype.sortDesc = function (predicate) {
        var records = sortBy(this.all(), predicate).reverse();
        return this.createCollection(records);
    };
    BeeModelCollection.prototype.reverse = function () {
        var records = this.all().reverse();
        return this.createCollection(records);
    };
    BeeModelCollection.prototype.get = function (key) {
        return this.all().map(function (m) { return m.get(key); });
    };
    BeeModelCollection.prototype.whereIn = function (key, values) {
        var _this = this;
        var predicate = key === "id"
            ? this.findById.bind(this)
            : key === "name"
                ? function (value) { return _this.modelsByNameHash[value]; }
                : (function (value) { return _this.all().find(function (x) { return x.get(key) === value; }); });
        var records = values.map(predicate).filter(Boolean);
        return this.createCollection(records);
    };
    return BeeModelCollection;
}());
export { BeeModelCollection };
